import { cva } from "class-variance-authority";

import { fieldSurfaceVariants } from "./input-variants";

export const asyncSelectTriggerVariants = cva("border shadow-xs", {
  variants: {
    variant: {
      outline: fieldSurfaceVariants({ variant: "outline" }),
      filled: [fieldSurfaceVariants({ variant: "filled" }), "font-normal"],
    },
  },
  defaultVariants: { variant: "outline" },
});

export const asyncSelectChipsVariants = cva("flex min-w-0 flex-1 flex-wrap gap-1");

export const asyncSelectContentVariants = cva(
  "flex max-h-[var(--radix-popover-content-available-height)] flex-col p-0 bg-transparent",
  {
    variants: {
      width: {
        trigger: "w-[var(--radix-popover-trigger-width)]",
        wide: "w-[max(var(--radix-popover-trigger-width),22rem)] max-w-[calc(100vw-2rem)]",
      },
    },
    defaultVariants: { width: "trigger" },
  },
);
